<template>
  <div>
    <el-form size="mini" style="margin-bottom: 5px;">
      <el-button type="primary" size="mini" @click="ue_addQtype" icon="el-icon-plus">增加</el-button>
    </el-form>
    <el-table :data="qtData"  :height="tb_height" stripe border size="mini">
      <el-table-column label="编码" prop="id" width="60"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="ue_EditQtype(scope.row)" size="mini" type="text" title="编辑">编辑
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="name" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column label="状态" :formatter="f_format" prop="status" width="100"></el-table-column>
      <el-table-column label="背景图" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <img :src="scope.row.bg_uri" title="点击查看大图" width="20" height="20" @click="ue_showImg(scope.row.bg_uri)"/>
        </template>
      </el-table-column>
      <el-table-column v-show="false" label="显示内容" :formatter="f_format" prop="content" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属公司" :formatter="f_format" prop="companyid" show-overflow-tooltip
                       width="150"></el-table-column>
    </el-table>
    <el-dialog title="资质类型维护"
               class="d-dialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="showEdit"
               width="550px">

      <el-form label-width="80px"
               size="mini"
               ref="Edit"
               :rules="rules"
               :model="Edit">
        <el-form-item label="编号">
          <el-input v-model="Edit.id" :disabled="true" placeholder="自动生成"></el-input>
        </el-form-item>
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="Edit.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-checkbox v-model="Edit.status" true-label="1" false-label="0">正常</el-checkbox>
        </el-form-item>
        <el-form-item label="背景图">
          <split-upload ref="bg_url"
                        :headers="uploadHeader"
                        :data="upparm"
                        :mustData="true"
                        :showfilelist="false"
                        :limit=1
                        :showPross="true"
                        :onExceed="f_exceed"
                        :SourceHost="shost"
                        :uploadHost="uploadHost+'/'+user.companyid"
                        :validateHost="validateHost+'/'+user.companyid"
                        :onSuccess="f_uploadSuccess"
                        exText=""
                        :deUrl="Edit.bg_uri"
                        accept=".jpg,.png,.bmp"
                        stype="bg_url"
                        exClass="el-icon-plus avatar-uploader-icon"></split-upload>
        </el-form-item>
        <el-form-item v-show="false" label="显示内容">
          <el-select v-model="Edit.content" multiple style="width: 100%;" placeholder="请选择，默认全部">
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="showEdit = false">关闭</el-button>
        <el-button size="mini" type="primary" @click.native="ue_saveQtype">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Utils from '../api/Utils'
  import * as Api from '../api/api'
  import SplitUpload from "./SplitUpload.vue";

  export default {
    components: {SplitUpload},
    data() {
      return {
        showEdit: false,
        qtData: [],
        upparm: {},
        tb_height:'400px',
        uploadHeader: {},
        user: JSON.parse(sessionStorage.getItem("user")),
        uploadHost: `${Api.Host}/file/fileSplit`,
        validateHost: `${Api.Host}/file/validateFile`,
        shost: Api.SourceHost,
        rules: {
          companyid: [
            {required: true, message: '请选择公司信息', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入资质名称', trigger: 'blur'}
          ]
        },
        Edit: {},
        companyData: []
      }
    },
    mounted() {
      this.f_GetCompany();
      this.upparm = {
        ftype: "bg_url"
      };
      this.f_GetQutype();
      window.onresize=()=>{
        this.f_AutoHeight();
      }
    },
    methods: {
      ue_addQtype() {
        this.showEdit = true;

        this.Edit = {
          name: "",
          status: "1",
          bg_url: "",
          content: "",
          companyid: this.user.companyid
        };
      },
      ue_EditQtype(row) {
        this.showEdit = true;
        this.Edit = JSON.parse(JSON.stringify(row));
      },
      ue_saveQtype() {
        this.$refs.Edit.validate((valid) => {
          if (valid) {
            if (!this.Edit.bg_uri || this.Edit.bg_uri === "") {
              this.$message.warning("请上传背景图");
              return false;
            }
            let parm = JSON.parse(JSON.stringify(this.Edit));
            let content = parm.content;
            if (content && content.length > 0)
              parm.content = content.toString();
            else
              parm.content = "";

            Api.AddQutype(parm).then(res => {
              if (res.code === 1) {
                this.showEdit = false;
                this.f_GetQutype();
              } else {
                this.$alert(`保存失败:${res.error}`, "提示信息");
              }
            })
          }
        });
      },
      ue_showImg(uri) {
        this.$alert(`<img src="${uri}" height="500"></img>`, 'HTML 片段', {
          dangerouslyUseHTMLString: true
        });
      },
      f_GetQutype() {
        Api.GetQutype({}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.qtData = res.data;
          this.f_AutoHeight();
        });
      },
      f_exceed(f, fl) {
        this.$message.warning("超出最大文件数限制");
      },
      f_uploadSuccess(res, type, file) {
        if (res.code === 1) {
          this.Edit.bg_uri = Api.SourceHost + res.data;
          this.$refs.bg_url.clearFiles();
        }
      },
      f_GetCompany() {
        Api.GetCompany({}).then(res => {
          if (res.code === 1)
            this.companyData = res.data;
        })
      },
      f_format(row, column, cellValue) {
        let col = column.property;
        let result = cellValue;
        if (col === "companyid") {
          let dd = this.companyData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "content") result = cellValue === "" ? "全部" : cellValue;
        if (col === "status") result = cellValue === "1" ? "正常" : "停用";
        return result;
      },
      f_AutoHeight () {
        //初始化界面计算明细表格高度
        let gd = document.getElementsByClassName('el-table')[0];
        let bb = document.getElementsByClassName('icp-footer')[0];
        let gh = Utils.GetElHeight(gd, bb);
        this.tb_height = '' + parseInt(gh)+'px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Qutype.vue